<script>
  import Icon from '../ui/icon.svelte'

  // The old CMS Content step's "App Preview" phone. `cards` arrive display-ready from
  // CampaignsController#campaign_preview (the campaign card, then one per adventure detail);
  // only which card is showing is chosen here.
  let { cards = [] } = $props()

  let index = $state(0)
  const card = $derived(cards[Math.min(index, cards.length - 1)] ?? null)
</script>

{#if card}
  <div class="flex flex-col gap-4 md:flex-row md:items-start">
    <ul class="menu menu-sm bg-base-200 rounded-box md:w-56 shrink-0">
      {#each cards as item, i (i)}
        <li>
          <button type="button" class={i === index ? 'bg-primary/10 text-primary font-medium' : ''} onclick={() => (index = i)}>
            <span class="flex flex-col items-start">
              <span class="text-xs text-base-content/60">{item.type}</span>
              <span class="truncate">{item.heading || 'Untitled'}</span>
            </span>
          </button>
        </li>
      {/each}
    </ul>

    <div class="mx-auto w-72 rounded-[2rem] border-4 border-base-300 bg-base-100 p-4 shadow-sm">
      <p class="text-lg font-bold">{card.feed}</p>
      <div class="mt-3 overflow-hidden rounded-box bg-base-200 aspect-[2/1] flex items-center justify-center">
        {#if card.image_url}
          <img src={card.image_url} alt={card.title} class="h-full w-full object-cover" />
        {:else}
          <Icon name="thumbnail" size="lg" class="text-base-content/30" />
        {/if}
      </div>
      {#if card.theme}<p class="mt-3 text-xs font-semibold tracking-wide text-base-content/60">{card.theme}</p>{/if}
      <p class="mt-1 font-semibold">{card.title}</p>
      {#if card.savings}
        <p class="mt-2 inline-flex items-center gap-1.5 text-sm text-primary">
          <span class="h-4 w-4 rounded-full bg-primary"></span>
          {card.savings}
        </p>
      {/if}
    </div>
  </div>
{/if}
